import Decimal from 'decimal.js';

const D = Decimal.clone({ precision: 50, rounding: Decimal.ROUND_HALF_UP });
const valid = (v: unknown) => typeof v === 'string' || typeof v === 'number';
export function exactPrice(v: string | number | null | undefined): string {
  if (!valid(v) || v === '' || v === null || v === undefined) return '—';
  try {
    const d = new D(v); if (!d.isFinite()) return '—';
    const raw = String(v); const text = /^-?\d+(\.\d+)?$/.test(raw) ? raw : d.toFixed();
    const [whole, fraction] = text.split('.');
    return '$' + whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (fraction !== undefined ? '.' + fraction : '');
  } catch { return '—'; }
}
export function exactINR(v: string | number | null | undefined = 0): string {
  if (!valid(v)) return '—';
  try {
    const d = new D(v!); if (!d.isFinite()) return '—';
    const negative = d.isNegative(); const [whole, fraction] = d.abs().toFixed(2).split('.');
    const last = whole.slice(-3); const start = whole.slice(0, -3).replace(/\B(?=(\d{2})+(?!\d))/g, ',');
    return (negative ? '-₹' : '₹') + (start ? start + ',' : '') + last + '.' + fraction;
  } catch { return '—'; }
}
export function percentFromPrices(price: string, base: string): number | null {
  try { const p = new D(price), b = new D(base); return b.gt(0) && p.isFinite() ? p.div(b).minus(1).times(100).toNumber() : null; } catch { return null; }
}
export function spreadBasisPoints(ask: string, bid: string, mark: string): number | null {
  try { const a = new D(ask), b = new D(bid), m = new D(mark); return a.gte(b) && m.gt(0) ? a.minus(b).div(m).times(10000).toNumber() : null; } catch { return null; }
}